import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography2 } from '@coursera/cds-core';
import { Box } from '@coursera/coursera-ui';

import { Spacer } from 'bundles/enterprise-ui/components';
import type { PrivateAuthoringQuery_EnterpriseAuthoringMappingsV1Resource_byThirdPartyOrganizationId_elements_partner as Partner } from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/__generated__/PrivateAuthoringQuery';

import _t from 'i18n!nls/internal-enterprise';

// Until the API is implemented, hard code the parterType mapping
const partnerTypeMap = ['University', 'Industry', 'Private Authoring'];

const PrivateAuthoringPartner: React.LegacyFunctionComponentWithChildren<{
  partner?: Partner | null;
}> = ({ partner, children }) => {
  if (!partner) return <div />;

  return (
    <Box alignItems="center">
      <div style={{ width: 64, height: 64, display: 'flex', alignItems: 'center' }}>
        {partner?.squareLogo && <Imgix src={partner.squareLogo} maxWidth={64} maxHeight={64} alt={partner?.name} />}
      </div>
      <Spacer size={24} />
      <div>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={`/teach-partner/${partner.shortName}/settings/institution-assets`}
        >
          {partner.name}
        </Link>
        <Typography2 component="p">
          <small>{_t('Slug: #{shortName}', partner)}</small>
        </Typography2>
        <Typography2 component="p">
          <small>{_t('Type: #{type}', { type: partnerTypeMap[partner.partnerType - 1] })}</small>
        </Typography2>
        {partner.display ? (
          <Typography2 component="p">
            <small>
              <strong>{_t('Displayed on Coursera.org')}</strong>
            </small>
          </Typography2>
        ) : null}
        {children}
      </div>
    </Box>
  );
};

export default PrivateAuthoringPartner;
